const actions = {
    ASYNC_SET_NAME({ state, commit, rootState }, payload) {
      setTimeout(() => {
        state.bName = 'asyncName'
      }, 4000)
    }
  }


export default {
    
}